import { Component, Input } from '@angular/core';
import { ObjectsService } from '@app/_services';
import {DomSanitizer} from "@angular/platform-browser";

@Component({
  selector: 'cards-item-ads',
  templateUrl: './cards-item-ads.component.html',
  styleUrls: ['./cards-item-ads.component.scss']
})
export class CardsSectionAdsComponent {
@Input() card: any;

constructor(private objectsService: ObjectsService, private sanitized: DomSanitizer) {}

  get header() {
    return this.objectsService.getValue(this.card, 'header-required'); 
  }

  get html() {
    let res = this.objectsService.getValue(this.card, 'html');
    return this.sanitized.bypassSecurityTrustHtml(res); 
  }

  get documents() {
    return this.objectsService.getValue(this.card, 'documents'); 
  }

}
